// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cellWrapper__container {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/CellWrapper/cellWrapper.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `cellWrapper__container`;
export default ___CSS_LOADER_EXPORT___;
